<template>
<div class="open-document" v-if="canOpen">
    <b-button variant="primary"
              :href="this.routes.assignmentAnswerEditor(this.partIn.id, projectId)"
              class="btn-open-document"
              target="_blank">
        <i class="btn-open icon"></i>Open document
    </b-button>

    <b-button variant="primary"
              class="btn-plagiarism"
              v-if="this.partIn.hasAnswer() && !$authUser.isStudent()"
              v-b-modal="'assignment-show-answer-editor-plagiarism-modal-' + this.partIn.getAnswer().id">
        Plagiaat
    </b-button>
    <design-2021-assignment-show-answer-editor-plagiarism-modal-component v-if="this.partIn.hasAnswer() && !$authUser.isStudent()"
                                                                          :answer-id="this.partIn.getAnswer().id">
    </design-2021-assignment-show-answer-editor-plagiarism-modal-component>
</div>
<div class="document-disabled" v-else>
    <b-button variant="primary"  class="btn-open-document" disabled><i class="btn-open"></i>Open document</b-button>

    <b-button variant="primary"
              class="btn-checked btn-open-document"
              v-if="this.partIn.hasAnswer() && !$authUser.isStudent()"
              v-b-modal="'assignment-show-answer-editor-plagiarism-modal-' + this.partIn.getAnswer().id">
        Plagiaat
    </b-button>
    <design-2021-assignment-show-answer-editor-plagiarism-modal-component v-if="this.partIn.hasAnswer() && !$authUser.isStudent()"
                                                                          :answer-id="this.partIn.getAnswer().id">
    </design-2021-assignment-show-answer-editor-plagiarism-modal-component>
</div>
</template>

<script>

    export default {
        name: "design-2021-assignment-show-answer-editor-component",
        props: ['partIn', 'canAnswer', 'projectId'],
        computed: {
            canOpen() {
                if (!this.projectId) {
                    return false;
                }

                return !this.$authUser.isStudent() || this.canAnswer;
            }
        }
    }
</script>

<style scoped lang="scss">
    .open-document {
        display: flex;
        align-items: center;
        flex-direction: row;

        .btn-open-document {
            display: flex;
            align-items: center;
            flex-direction: row;
            line-height: 1;

            .icon {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        .btn-plagiarism {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
</style>
